export default __webpack_public_path__ + "static/media/projects5.efcab3e4.jpg";